import styled, { css } from 'styled-components';
export const IconContainer = styled.div `
  position: relative;
  top: -1px;
  z-index: 1;
  flex-shrink: 0;
  margin-right: var(--space-500);
  width: 9px;
  height: 9px;

  border: 1px solid var(--text-primary);
  border-radius: 50%;

  background-color: var(--bg-primary);

  ${({ $completed }) => $completed &&
    css `
      background-color: var(--text-primary);
    `}
`;
export const Description = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
export const Time = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-100);
  letter-spacing: var(--font-letter-spacing-loosest);
  text-transform: uppercase;
`;
export const Title = styled.div `
  max-width: 400px;

  ${({ $size }) => $size === 'small' &&
    css `
      max-width: 192px;
    `}
`;
export const Container = styled.ul `
  position: relative;

  font-size: var(--font-size-400);

  ${({ $size }) => $size === 'small' &&
    css `
      font-size: var(--font-size-300);
    `}
`;
export const DateSection = styled.div `
  display: flex;
  position: relative;
  margin-bottom: var(--space-600);
  margin-top: var(--space-800);
  margin-left: var(--space-800);

  font-size: var(--font-size-100);
  color: var(--text-secondary);
  letter-spacing: var(--font-letter-spacing-loosest);
  line-height: var(--font-line-height-100);
  text-transform: uppercase;

  &:first-child {
    margin-top: 0px;

    &::before {
      display: none;
    }
  }

  &:after {
    content: '';
    position: relative;
    top: var(--space-150);
    flex: 1;
    margin-left: var(--space-400);
    height: 1px;
    background: var(--border-secondary);
  }

  &::before {
    content: '';
    position: absolute;
    left: calc(-1 * var(--space-700));
    top: var(--space-n500);
    display: block;
    height: calc(100% + 60px);
    width: 1px;
    background-color: var(--border-secondary);
  }

  ${({ $size }) => $size === 'small' &&
    css `
      margin-top: var(--space-400);
      margin-bottom: var(--space-400);
      font-size: var(--font-size-100);
    `}
`;
export const Item = styled.li `
  position: relative;
  display: flex;
  align-items: baseline;
  margin-bottom: var(--space-400);

  &:last-of-type {
    margin-bottom: 0px;

    &::before {
      display: none;
    }
  }

  ${({ $size }) => $size === 'small' &&
    css `
      &:last-of-type::after {
        content: '';
        display: block;
        position: absolute;
        top: var(--space-300);
        left: var(--space-100);
        width: 1px;
        height: calc(100% + var(--space-500));
        background: var(--border-secondary);
      }
    `}

  &::before {
    content: '';
    position: absolute;
    left: var(--space-100);
    top: var(--space-200);
    display: block;
    height: calc(100% + var(--space-400));
    width: 1px;
    background-color: var(--border-secondary);
  }

  ${({ $completed }) => !$completed &&
    css `
      &::before,
      & + ${DateSection}:first-of-type::before, & + ${DateSection}::before {
        background: linear-gradient(var(--border-secondary) 50%, rgba(255, 255, 255, 0) 0) right /
          1px 9px repeat-y transparent;
      }

      & + ${DateSection}:first-of-type::before, & + ${DateSection}::before {
        display: block;
      }
    `}

  ${({ $size }) => $size === 'small' &&
    css `
      margin-bottom: var(--space-400);
    `}
`;
